export class SentryException extends Error {
  constructor(message: string, data: any) {
    super(typeof data === "object" ? JSON.stringify(data) : data);
    this.name = message;
  }
}
